import { BaseComponent } from '../../shared/base/base-component/base-component.component';
import { LayoutService } from '../services/layout.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { PageHeaderComponentModel } from '../interfaces/page-header-component-model';
import { ConnectionService } from '../services/connection.service';
import { Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormComponentModel } from './form-component-model';
import { AppConfigService } from '../services/app-config.service';

export abstract class CreateComponentModel extends BaseComponent {
  model: string;
  mode = 'create';
  layoutModelsLoaded = false;
  submitting = false;
  componentModel: PageHeaderComponentModel;

  formGroup: FormGroup;

  constructor(injector: Injector) {
    super(injector);
    this.route.params.subscribe((d) => {
      this.layoutModelsLoaded = false;
      this.formGroup = this.fb.group({});
      this.model = d['model'];

      this.formGroup = this.fb.group(
        FormComponentModel.getControls(this.model, this.mode)
      );
      this.layoutService.getPageHeaderComponent(
        this.model,
        'create',
        (d: PageHeaderComponentModel) => {
          this.componentModel = d;
          this.layoutModelsLoaded = true;
          this.recordDetailsLoaded();
        }
      );
    });
  }

  override submit(record?: any): void {
    this.submitting = true;
    const newRecord = this.beforeSubmit();
    if (newRecord != null) {
      record = newRecord;
    }
    if (this.formGroup.valid) {
      // ****Giving the ability to handle the object before submitting it****//
      const values = record ?? this.formGroup.value;
      if (
        values.AttributeValues != null &&
        !Array.isArray(values.AttributeValues)
      ) {
        values.AttributeValues = [];
      }

      let endPoint = `${AppConfigService.settings.baseUrl}data-api/${encodeURI(
          this.componentModel.endPoint
        )}`;

      if(this.componentModel.customCreateEndPoint != null && this.componentModel.customCreateEndPoint === undefined && this.componentModel.customCreateEndPoint !== '') {
        endPoint = `${AppConfigService.settings.baseUrl}${encodeURI(this.componentModel.customCreateEndPoint)}`;
      }

      const _values = this.cleanRecord(values);

      this.connectionService.create(endPoint,
        _values,
        (record) => {
          this.afterSubmit(record);
          this.router.navigate([this.componentModel.editPath, (record.Id === undefined ? record.id : record.Id)]);
          const message = this.getCreateSuccessfullyMessage(record);
          this.message.success(message);
          this.submitting = false;
        }
      );
    } else {
      const errors: string[] = [];
      Object.keys(this.formGroup.controls).forEach((controlName) => {
        const control = this.formGroup.get(controlName) as FormControl;
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
          errors.push(`<li>${controlName}</li>`);
        }
      });

      this.notification.error(
        'Please check the next field(s):',
        `<ul>
        ${errors.join('')}
        </ul>`
      );
      this.submitting = false;
    }
  }

  abstract getCreateSuccessfullyMessage(record: any): string;
  abstract recordDetailsLoaded(): void;
  abstract beforeSubmit(): any | void;
  abstract cleanRecord(record: any): any;
  abstract afterSubmit(record: any): void;
}
